import {Button, Slide} from '../../types'
import {BTN_TYPE} from 'src/constants'
import isObject from 'lodash/isObject'

export function createButton(mButton) {
  let button = new Button()
  button.text = mButton.text
  button.value = mButton.value
  button.type = mButton.type || BTN_TYPE.PAYLOAD
  button.name = mButton.name
  return button
}

export function createQuickReply(mQuickReply) {
  // ALlow both simple strings as buttons and objects with type, value to support urls
  if (!isObject(mQuickReply)) {
    return createButton({ text: mQuickReply, type: BTN_TYPE.PAYLOAD })
  }
  return createButton(mQuickReply)
}

export function createSlide(mCard) {
  let slide = new Slide()
  slide.title = mCard.title
  slide.subtitle = mCard.subtitle
  slide.image = mCard.image
  slide.image_link = mCard.image_link
  slide.buttons = mCard.buttons && mCard.buttons.map(createButton)
  return slide
}



// WEBPACK FOOTER //
// ./src/App/services/adapters/botapi/helpers.js